import { Phone, Mail, Check } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { CONTACT } from "../config/site";

export const Contact = () => (
    <section id="kontakt" data-testid="contact-section" className="py-20 sm:py-28">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <SectionHeading
                kicker="Kontakt"
                title="Masz pytanie przed zakupem? Napisz lub zadzwoń"
            />
            <Reveal delay={0.1}>
                <article className="mt-12 rounded-[2rem] bg-white border border-border shadow-card overflow-hidden grid md:grid-cols-[38%_1fr]">
                    <div className="bg-cream-deep">
                        <img
                            src={CONTACT.photo}
                            alt={`${CONTACT.name} - kontakt w sprawie kursów EduNation`}
                            loading="lazy"
                            className="w-full h-full object-cover object-top max-h-80 md:max-h-none"
                        />
                    </div>
                    <div className="p-8 sm:p-10">
                        <h3 className="font-display text-2xl font-bold text-ink">
                            {CONTACT.name}
                        </h3>
                        <p className="mt-1 text-sm font-semibold text-ink-mute">
                            Opieka nad uczestnikami kursów EduNation
                        </p>

                        <div className="mt-7 flex flex-col sm:flex-row gap-3">
                            <a
                                data-testid="contact-phone-link"
                                href={CONTACT.phoneHref}
                                className="inline-flex items-center justify-center gap-2 rounded-full bg-tang hover:bg-[#EFE238] text-ink font-bold px-6 min-h-[48px] text-sm transition-colors duration-300"
                            >
                                <Phone className="w-4 h-4" />
                                {CONTACT.phoneDisplay}
                            </a>
                            <a
                                data-testid="contact-email-link"
                                href={`mailto:${CONTACT.email}`}
                                className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-ink/15 hover:border-brand-500 hover:text-brand-600 text-ink font-semibold px-6 min-h-[48px] text-sm transition-colors duration-300 break-all"
                            >
                                <Mail className="w-4 h-4 shrink-0" />
                                {CONTACT.email}
                            </a>
                        </div>

                        <p className="mt-8 text-xs font-bold uppercase tracking-[0.18em] text-ink-mute">
                            Pomogę Ci w sprawie:
                        </p>
                        <ul className="mt-3 grid sm:grid-cols-2 gap-2.5">
                            {CONTACT.scope.map((s) => (
                                <li
                                    key={s}
                                    className="flex items-center gap-2 text-sm text-ink-soft"
                                >
                                    <Check className="w-4 h-4 text-ink shrink-0" strokeWidth={3} />
                                    {s}
                                </li>
                            ))}
                        </ul>
                    </div>
                </article>
            </Reveal>
        </div>
    </section>
);
